import hyderabadBg from "./assets/images/hyderabad/banner.png";
import delhibg from "./assets/images/delhi/bg.JPG";
import bangalorebg from "./assets/images/bangalore/bg.jpg";
import mumbaibg from "./assets/images/mumbai/bg.jpg";
import MiyaPur from "./assets/images/hyderabad/Miyapur.jpg";
import Suchitra from "./assets/images/hyderabad/Suchitra.jpg";
import Himayatnagar from "./assets/images/hyderabad/Himayatnagar.jpg";
import LaxmiNagar from "./assets/images/delhi/LaxmiNagar.jpg";
import Saket from "./assets/images/delhi/Saket.jpg";
import Janakpuri from "./assets/images/delhi/Janakpuri.jpg";
import KarolBagh from "./assets/images/delhi/KarolBagh.jpg";
import Noida from "./assets/images/delhi/Noida.jpg";
import Rajaji from "./assets/images/bangalore/Rajaji.jpg";
import Koramangala from "./assets/images/bangalore/Koramangala.jpg";
import Nagavara from "./assets/images/bangalore/Nagavara.jpg";
import Whitefield from "./assets/images/bangalore/Whitefield.jpg";
import Banashankari from "./assets/images/bangalore/Banashankari.jpg";
import Andheri from "./assets/images/mumbai/Andheri.jpg";
import Chennai from "./assets/images/chennai/Chennai.jpg";
import chennaibg from "./assets/images/chennai/bg.jpg";

export const CITY_JSON = {
  hyderabad: {
    name: "Hyderabad",
    bg: hyderabadBg,
    branches: [
      {
        name: "Jublee Hills",
        address:
          "1st Floor, Plot #769, Rd Number 44, behind IMI Mobiles, near State Art Gallery, CBI Colony, Jubilee Hills, Hyderabad, Telangana 500033",
        mapLink: "https://maps.app.goo.gl/Myw493HmCoQGuQf19",
        image: hyderabadBg,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-hyderabad/private-celebration-venue-in-jubilee%20hills",
        theatres: 4,
      },
      {
        name: "Miyapur",
        address:
          "1st Floor, 2-83, NH 65, above Bandhan Bank, Chanda Nagar, Miyapur, Hyderabad, Telangana 500050",
        mapLink: "https://maps.app.goo.gl/xcPQURqNZVLMWrjw8",
        image: MiyaPur,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-hyderabad/private-celebration-venue-in-miyapur",
        theatres: 3,
      },
      {
        name: "Himayatnagar",
        address:
          "3rd Floor, Above Hot Tracks, Near Cafe Bahar, Raja Reddy Marg, Himayatnagar, Hyderabad, Telangana 500029",
        mapLink: "https://maps.app.goo.gl/UmTGiwbyEwhMZnzMA",
        image: Himayatnagar,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-hyderabad/private-celebration-venue-in-himayatnagar",
        theatres: 3,
      },
      {
        name: "Suchitra",
        address:
          "Plot #20, Venkateshwara Colony, Besides Anutex, Suchitra Rd, Hyderabad, Telangana 500067",
        mapLink: "https://maps.app.goo.gl/849vpvyGMk79TdLa8",
        image: Suchitra,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-hyderabad/private-celebration-venue-in-suchitra%20circle",
        theatres: 2,
      },
    ],
    metadata: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "The Binge Town - Hyderabad Private Theaters",
      description:
        "Experience luxury and privacy at The Binge Town's private theaters in Hyderabad. Book your celebrations today!",
      telephone: "+91-8618976974",
      image: "https://thebingetown.com/hyderabad-landing-page.jpg",
      priceRange: "$",
      url: "https://thebingetown.com/hyderabad-private-theatres",
      sameAs: [
        "https://facebook.com/thebingetown",
        "https://www.instagram.com/bingetown_in",
      ],
      logo: "https://www.thebingetown.com/TBT.jpeg",
    },
  },
  delhi: {
    name: "Delhi NCR",
    bg: delhibg,
    branches: [
      {
        name: "Janakpuri",
        address:
          "3rd Floor, #3, above Her Fitness, opp. Mata Chanan Devi Hospital, Block C1, Janakpuri, Delhi, 110058",
        mapLink: "https://maps.app.goo.gl/Cuw2WVxt6EBYdeNQA",
        image: Janakpuri,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-delhi/private-celebration-venue-in-janakpuri",
        theatres: 4,
      },
      {
        name: "Laxmi Nagar",
        address:
          "3rd Floor, D-32, near Laxmi Nagar Metro Station, above Domino's, Delhi, 110092",
        mapLink: "https://maps.app.goo.gl/aHKhdT3wqun4ZfNeA",
        image: LaxmiNagar,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-delhi/private-celebration-venue-in-laxmi%20nagar",
        theatres: 6,
      },
      {
        name: "Saket",
        address:
          "Ground Floor, K261, Lane No 5, Westend Marg, Saiyad Ul Ajaib Extension, Saket, New Delhi, Delhi 110030",
        mapLink: "https://maps.app.goo.gl/AHP1BBRWEZ3okLx28",
        image: Saket,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-delhi/private-celebration-venue-in-saket",
        theatres: 5,
      },
      {
        name: "Karol Bagh",
        address:
          "1st Floor, 3C/8, New Rohtak Rd, opp. Liberty Cinemas, Block 3C, Karol Bagh, New Delhi, Delhi, 110005",
        mapLink: "https://maps.app.goo.gl/jsEJuSbBv2HbmXPW9",
        image: KarolBagh,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-delhi/private-celebration-venue-in-karol%20bagh",
        theatres: 6,
      },
      {
        name: "Noida",
        address:
          "4th Floor, CRD Complex, Hazipur, Sector 104, Noida, Uttar Pradesh, 210304, India",
        mapLink: "https://maps.app.goo.gl/4Bory5Y6rpRi5iXP9?g_st=iw",
        image: Noida,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-delhi/private-celebration-venue-in-noida",
        theatres: 3,
      },
    ],
    metadata: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "The Binge Town - Private Theaters in delhi",
      description:
        "Experience luxury and privacy at The Binge Town's private theaters in Delhi. Book your celebrations today!",
      address: {
        "@type":
          "1Ground Floor, K261, Lane No 5, Westend Marg, Saiyad Ul Ajaib Extension, Saket, New Delhi, Delhi 110030",
        addressCountry: "IN",
      },
      telephone: "+91-8618976974",
      image: "https://thebingetown.com/Del-landing-page.jpg",
      priceRange: "$",
      url: "https://thebingetown.com/private-theatres-in-delhi",
      sameAs: [
        "https://facebook.com/thebingetown",
        "https://www.instagram.com/bingetown_in",
      ],
    },
  },
  bengaluru: {
    name: "Bengaluru",
    bg: bangalorebg,
    branches: [
      {
        name: "Koramangala",
        address:
          "SM Complex, Hosur Rd, Madiwala, Santhosapuram, Koramangala 2nd Block, Koramangala, Bengaluru, Karnataka 560068",
        mapLink: "https://maps.app.goo.gl/4HMF7Rvaf56g4fRY7",
        image: Koramangala,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-bangalore/private-celebration-venue-in-koramangala",
        theatres: 2,
      },
      {
        name: "Rajaji Nagar",
        address:
          "Ram Mandir, 1st Floor, Shree Lakshmi, 59th Cross Road, Road, 4th Block, Rajajinagar, Bengaluru, Karnataka 560010",
        mapLink: "https://maps.app.goo.gl/9Kyx2X6D3ceWH4Yq5",
        image: Rajaji,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-bangalore/private-celebration-venue-in-rajaji%20nagar",
        theatres: 3,
      },
      {
        name: "Banashankari",
        address:
          "1st Floor, SLV Arcade, 100 Feet Ring Road, above Sangeetha Mobiles, 5th Phase, Banashankari 3rd Stage, Banashankari, Bengaluru, Karnataka 560085",
        mapLink: "https://maps.app.goo.gl/Abo1HjxTT2fRTRjF8",
        image: Banashankari,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-bangalore/private-celebration-venue-in-banashankari",
        theatres: 3,
      },
      {
        name: "Whitefield",
        address:
          "2nd Floor, 10/1, Behind Detailing Mafia Graphite India Road, Hoodi, Whitefield, Bengaluru, Karnataka 560048",
        mapLink: "https://maps.app.goo.gl/Xp14xRXn63HV3n9A9",
        image: Whitefield,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-bangalore/private-celebration-venue-in-whitefield",
        theatres: 3,
      },
      {
        name: "Nagavara",
        address:
          "3rd Floor, FJ Complex, 3rd Cross Rd, above Reliance Smart Point, Mariyannapalya, Nagavara, Bengaluru, Karnataka 560025",
        mapLink: "https://maps.app.goo.gl/xXV2oKBQaN3XojEf7",
        image: Nagavara,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-bangalore/private-celebration-venue-in-nagavara",
        theatres: 3,
      },
    ],
    metadata: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "The Binge Town - Private Theaters in bengaluru",
      description:
        "Experience luxury and privacy at The Binge Town's private theaters in Bengaluru. Book your celebrations today!",
      address: {
        "@type":
          "10/1B, Graphite India Road, Hoodi Village, KR Puram, Bengaluru,560048, Karnataka, India",
        addressLocality: "Bengaluru",
        addressCountry: "IN",
      },
      telephone: "+91-8618976974",
      image: "https://thebingetown.com/Blr-landing-page.jpg",
      priceRange: "$",
      url: "https://thebingetown.com/private-theatres-in-bengaluru",
      sameAs: [
        "https://facebook.com/thebingetown",
        "https://www.instagram.com/bingetown_in",
      ],
    },
  },

  mumbai: {
    name: "Mumbai",
    bg: mumbaibg,
    branches: [
      {
        name: "Andheri",
        address:
          "2nd floor, G wing, Tex Centre, Narayan Plaza, Chandivali, Andheri, Mumbai, 400072",
        mapLink: "https://maps.app.goo.gl/3PHgR9dzrdXpNEoV9",
        image: Andheri,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-mumbai/private-celebration-venue-in-andheri",
        theatres: 6,
      }
    ],
    metadata: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "The Binge Town - Private Theaters in mumbai",
      description:
        "Experience luxury and privacy at The Binge Town's private theaters in Mumbai. Book your celebrations today!",
      address: {
        "@type":
          "2nd floor, G wing, Tex Centre, Narayan Plaza, Chandivali, Andheri, Mumbai, 400072",
        addressLocality: "Mumbai",
        addressCountry: "IN",
      },
      telephone: "+91-8618976974",
      image: "https://thebingetown.com/Mbi-landing-page.jpg",
      priceRange: "$",
      url: "https://thebingetown.com/private-theatres-in-mumbai",
      sameAs: [
        "https://facebook.com/thebingetown",
        "https://www.instagram.com/bingetown_in",
      ],
    },
  },

  chennai: {
    name: "Chennai",
    bg: chennaibg,
    branches: [
      {
        name: "Omr Perungudi",
        address:
          "First floor, No 4/986, HA Stays Building, Rajiv Gandhi Salai, OMR, Perungudi, Chennai, Tamil Nadu, 600041",
        mapLink: "https://maps.app.goo.gl/SW8zk6rUyndesAhH8",
        image: Chennai,
        theatreLink:
          "https://thebingetown.com/private-theatres-in-chennai/private-celebration-venue-in-omr%20perungudi",
        theatres: 2,
      }
    ],
    metadata: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "The Binge Town - Private Theaters in chennai",
      description:
        "Experience luxury and privacy at The Binge Town's private theaters in Chennai. Book your celebrations today!",
      address: {
        "@type":
          "Maruti Ventures, No 5, 6 & 7, 1st floor, Gandhi Street, Kottivakkam, OMR, Chennai 600041",
        addressLocality: "Chennai",
        addressCountry: "IN",
      },
      telephone: "+91-8618976974",
      image: "https://thebingetown.com/Cni-landing-page.jpg",
      priceRange: "$",
      url: "https://thebingetown.com/private-theatres-in-chennai",
      sameAs: [
        "https://facebook.com/thebingetown",
        "https://www.instagram.com/bingetown_in",
      ],
    },
  },
};

export const EVENTS_JSON = {
  BIRTHDAY: {
    heading1: "BIRTHDAY",
    heading2: "CELEBRATIONS",
    host: {
      heading: "Host an Unforgettable Private Theater Birthday Party !",
      description:
        "Luxury private movie experience with Private screens, Surround Sound & Luxury seating.",
    },
    celebration_types: {
      heading: "Celebrate All Types of Birthdays in a Private Theatre",
      description:
        "From kids' birthdays to milestone celebrations, enjoy a private cinematic experience like no other. Our private theaters cater to:",
      items: [
        "Kids' Birthday Parties - Fun themes, cartoons & animated movies.",
        "Teen Birthday Bashes - Action-packed films, gaming parties & more.",
        "Sweet 16 Celebrations - A stylish private movie night with friends.",
        "Lover's Birthday - Romantic movie night with cozy setup & personalized messages.",
        "Parents' Birthday - Memory lane screening with family videos & special moments.",
        "Friends' Birthday Bash - Fun, laughter & themed movie nights.",
      ],
    },
  },
  ANNIVERSARY: {
    heading1: "ANNIVERSARY",
    heading2: "CELEBRATIONS",
    host: {
      heading: "Celebrate an Unforgettable Anniversary in a Private Theater",
      description:
        "Make your anniversary unforgettable with a luxury private theatre experience. enjoy a romantic and intimate setting with personalised touches.",
    },
    celebration_types: {
      heading: "Types of Anniversaries You Can Celebrate",
      description:
        "Enjoy a private cinematic experience for your anniversary, whether it's a romantic evening, 'a family gathering, or a special milestone.",
      items: [
        "Romantic Wedding Anniversary - A private movie night with cozy ambiance & personalized messages.",
        "Parents' Anniversary - A heartfelt tribute with family videos & special moments.",
        "Friendship Anniversary - Celebrate lifelong friendships with a fun movie night.",
        "Employee Work Anniversary - Recognize achievements with a tribute video & team appreciation.",
        "Relationship Anniversary - Strengthen bonds with a nostalgic screening & themed decor.",
        "Golden Jubilee Anniversary - Celebrate 50 years of love with a special family movie night.",
      ],
    },
  },
  PARTY_AND_EVENTS: {
    heading1: "PARTY &",
    heading2: "EVENTS",
    host: {
      heading:
        "Celebrate an Unforgettable Paarty & Events at a Private Theater",
      description:
        "Host unforgettable private events with a luxury theater experience! Perfect for birthdays, anniversaries, corporate events, proposals, and more",
    },
    celebration_types: {
      heading: "Special Celebrations We Host",
      items: [
        "Bride-to-Be Celebration - A fun & glamorous movie night with friends.",
        "Romantic Proposal - Surprise your partner with a private movie screening & a heartfelt proposal.",
        "Kids' Birthday Party - Fun themes, cartoons & a magical experience.",
        "Corporate Hangouts - Private screening for team bonding & relaxation.",
        "Movie Night with Friends - Watch your favorite films in an exclusive setting.",
        "Reunion Movie Night - Reconnect with old friends or classmates over a nostalgic screening.",
      ],
    },
  },
};
